import React from "react";
import { useNavigate } from "react-router-dom";

// icons
import { LuMail, LuLock } from "react-icons/lu";

// components

// theme
import { authUser } from "../../../services/apis/auth";
import { get_cookie } from "../../../utility/cookies";
import TextInput from "../../../component/element/forms/TextInput";
// import { service } from "../../../store/slices/services";
import { useAppDispatch, useAppSelector } from "../../../store";
import { IAuthError, IAuthUser } from "../../../store/types/user";
import Button from "../../../component/element/forms/Button";

const Login = () => {
  const [data, setData] = React.useState<IAuthUser>({
    email: "",
    password: "",
  });
  const [error, setError] = React.useState<IAuthError>({
    email: "",
    password: "",
  });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector(({ loading }) => loading.loading);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
    if (error[name]) {
      setError((prevError) => ({ ...prevError, [name]: "" }));
    }
  };

  const onFinish = async () => {
    const newError: IAuthError = {
      email: !data.email ? "warning" : "",
      password: !data.password || data.password.length < 3 ? "warning" : "",
    };

    setError(newError);

    // Stop execution if any errors exist
    if (newError.email || newError.password) return;

    // Proceed with authentication
    authUser(data, dispatch, navigate);
  };

  React.useEffect(() => {
    const serial = get_cookie("@serial");
    if (serial) navigate("/");
  }, [navigate]);

  return (
    // <AuthScreen>
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-customgreen flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 space-y-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Welcome back
          </h1>
          <p className="text-gray-600">Please sign in to continue</p>
        </div>

        <div className="space-y-6">
          <div>
            <TextInput
              label="Email"
              icon={<LuMail size={24} />}
              name="email"
              type="email"
              value={data.email}
              status={error.email}
              onChange={onChange}
              placeholder="user@email.com"
            />
            {error.email && (
              <p className="text-[red] text-xs mt-1">
                Email field cannot be empty
              </p>
            )}
          </div>
          <div>
            <TextInput
              label="Password"
              icon={<LuLock size={24} />}
              name="password"
              type="password"
              value={data.password}
              status={error.password}
              onChange={onChange}
              placeholder="********"
            />
            {error.password && (
              <p className="text-[red] text-xs mt-1">
                Password field cannot be empty
              </p>
            )}
          </div>
          <Button
            type="submit"
            title="Sign in"
            onClick={onFinish}
            loading={loading}
            className="w-full bg-primary-500 text-base text-white rounded-lg font-medium hover:bg-primary-900 transition-colors duration-200"
          />
        </div>
      </div>
    </div>
    // </AuthScreen>
  );
};

export default Login;
